export default "__VITE_ASSET__CtlmP_nu__"